import React from "react";
//#region types
import { NavigationListProps, NavListItemProps } from "models/propTypes/navListPropTypes";
//#endregion
//#region components
import NavigationTreeView from "./listItems/treeView";
import NavigationRootItem from "./listItems/rootItem";
//#endregion

const NavigationListItem: React.FC<NavListItemProps & NavigationListProps> = (props) => {
  return !props.hidden ? (
    props.children ? (
      <NavigationTreeView {...props} />
    ) : (
      <NavigationRootItem {...props} root />
    )
  ) : (
    <></>
  );
};

export default NavigationListItem;
